import { BaseQueryFn, EndpointBuilder, FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { Document } from 'services/documents/types/dtos';
import { Place, ResponsePlaceDto } from '../types/dtos';
import { APP_ENDPOINTS } from 'app/endpoints';

type LogoType = 'original' | 'medium' | 'thumbnail' | 'small';

const extractLogo = (logo: Document, type: LogoType) => JSON.parse(logo.filePaths)[type];

export default (builder: EndpointBuilder<BaseQueryFn, string, string>) =>
    builder.query<Place, string>({
        async queryFn(placeId, _queryApi, _extraOptions, fetchWithBQ) {
            const placeResult = await fetchWithBQ(`${APP_ENDPOINTS.PLACE}/${placeId}`);

            if (placeResult.error) return { error: placeResult.error as FetchBaseQueryError };

            const place = placeResult.data as ResponsePlaceDto;

            if (place.documentId) {
                const documentResult = await fetchWithBQ(`${APP_ENDPOINTS.DOCUMENT}/${place.documentId}`);
                if (documentResult.error) return { error: documentResult.error as FetchBaseQueryError };
                const document = documentResult.data as Document;
                return {
                    data: { ...place, logo: extractLogo(document, 'small') },
                };
            }
            return {
                data: place,
            };
        },
        providesTags: [{ type: 'place', id: 'GET-ID' }],
    });
